/**
 * Created by Administrador on 25/09/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('specialInvoiceCtrl', specialInvoiceCtrl)
        .controller('newSpecialInvoiceCtrl', newSpecialInvoiceCtrl)
        .controller('viewSpecialInvoiceCtrl', viewSpecialInvoiceCtrl)
        .controller('annularSpecialInvoiceCtrl', annularSpecialInvoiceCtrl);

    specialInvoiceCtrl.$inject = ['specialInvoices','linkService','reprintService','printService'];
    newSpecialInvoiceCtrl.$inject = ['documentTypes','activities','products','specialInvoiceService','printService','linkService','siatService'];
    viewSpecialInvoiceCtrl.$inject = ['specialInvoice'];
    annularSpecialInvoiceCtrl.$inject = ['specialInvoiceService', '$uibModalInstance', '$stateParams'];

    function specialInvoiceCtrl(specialInvoices,linkService,reprintService,printService) {
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];
        vm.specialInvoices = (specialInvoices.data._embedded) ? specialInvoices.data._embedded.saleInvoices : [];
        vm.invoiceHtml = [];
        vm.pages = specialInvoices.data.page;

        vm.generatePdf = function(invoiceNumber, nitClient){
            reprintService.getByInvoiceNumberAndNitClient(invoiceNumber, nitClient)
                .then(function(response){
                    vm.invoiceHtml = response.data.ticket;
                    if(vm.invoiceHtml != undefined){
                        setTimeout(function(){
                            printService.printIFrame('invoiceHtml');
                            linkService.reloadRoute('specialInvoices');
                        },300);
                    }
                })
        }
    }

    function newSpecialInvoiceCtrl(documentTypes,activities,products,specialInvoiceService,printService,linkService,siatService) {
        var vm = this;
        //vm.taxpayer = taxpayer.data;
        //vm.dosage = dosage.data;
        vm.isDisabled = false;
        vm.invoiceHtml = [];
        vm.documentTypeList = documentTypes.data.documentTypeList;
        vm.measureUnitList = documentTypes.data.measureUnitList;
        vm.documentType = null;
        vm.activity = null;
        vm.productList = [];
        vm.activities = activities.data.listaActividades;
        vm.products = products.data.listaCodigos;

        vm.specialInvoice = {
            client: '',
            nit: '',
            amount: 0,
            complement: '',
            documentType: 0,
            activityDescription: '',
            rbcTransactionSales: [
                {
                    quantity: '',
                    concept: '',
                    unitPrice: '',
                    totalAmount: '',
                    activityEconomic: '',
                    codeProductSin: '',
                    unitMeasure: null,
                    unit: null,
                    codeProduct: null
                }
            ]
        };

        vm.addDetail = function(){
            vm.specialInvoice.rbcTransactionSales.push({
                quantity: '',
                concept: '',
                unitPrice: '',
                totalAmount: '',
                activityEconomic: '',
                codeProductSin: '',
                unitMeasure: null,
                unit: null,
                codeProduct: null
            });
            vm.calculateTotalAmount();
        }

        vm.removeDetail = function(index){
            vm.specialInvoice.rbcTransactionSales.splice(index, 1);
            vm.calculateTotalAmount();
        }
        vm.calculationPrice = function(index){
            // var number = parseFloat(vm.specialInvoice.rbcTransactionSales[index].quantity * parseFloat(vm.toFixedTrunc(vm.specialInvoice.rbcTransactionSales[index].unitPrice, 2)) );
            var number = parseFloat(vm.specialInvoice.rbcTransactionSales[index].quantity * parseFloat(vm.specialInvoice.rbcTransactionSales[index].unitPrice).toFixed(3).slice(0,-1) );
            vm.specialInvoice.rbcTransactionSales[index].totalAmount = Math.round((number + Number.EPSILON) * 100) / 100; // Math.round(number * 100) / 100;
            if(vm.specialInvoice.rbcTransactionSales[index].totalAmount<=0){
                vm.specialInvoice.rbcTransactionSales[index].unitPrice = '';
            }
            vm.calculateTotalAmount();
        };

        vm.calculateTotalAmount = function(){
            var j = 0;
            vm.specialInvoice.amount = 0;
            angular.forEach(vm.specialInvoice.rbcTransactionSales, function (i) {
                var number = parseFloat(vm.specialInvoice.amount + vm.specialInvoice.rbcTransactionSales[j].totalAmount);
                vm.specialInvoice.amount = Math.round((number + Number.EPSILON) * 100) / 100; // Math.round(number * 100) / 100;
                j++;
            });
        };

        // this function only is getting two decimals
        vm.toFixedTrunc = function(x, n) {
            var v = (typeof x == 'string' ? x : x.toString()).split('.');
            if (n <= 0) return v[0];
            var f = v[1] || '';
            if (f.length > n) return v[0] + '.' + f.substr(0,n);
            while (f.length < n) f += '0';
            return v[0] + '.' + f;
        };

        vm.saveSpecialInvoice = function(isValid, specialInvoice){
            if(isValid) {
                specialInvoiceService.saveSpecialInvoice(specialInvoice)
                    .then(function(response){
                        vm.invoiceHtml = response.data;
                        if(response.data != undefined){
                            setTimeout(function(){
                                printService.print('invoiceHtml');
                                linkService.reloadRoute('specialInvoices');
                            },300);
                        }
                    });
            }
        }

        vm.changeDocumentType = function() {
            vm.specialInvoice.documentType = vm.documentType.id;
        }

        vm.changeActivity = function() {
            vm.specialInvoice.activityDescription = vm.activity.descripcion;
            vm.productList = siatService.getProductsByCode(vm.activity.codigoCaeb, vm.products);
            angular.forEach(vm.specialInvoice.rbcTransactionSales, function(transactionSale) {
                transactionSale.activityEconomic = '';
                transactionSale.codeProductSin = '';
                transactionSale.unitMeasure = null;
                transactionSale.unit = null;
                transactionSale.codeProduct = null;

            });
        }

        vm.changeProduct = function(index) {
            vm.transactionSale = vm.specialInvoice.rbcTransactionSales[index];
            vm.specialInvoice.rbcTransactionSales[index].codeProductSin = '' + vm.transactionSale.codeProduct.codigoProducto;
            vm.specialInvoice.rbcTransactionSales[index].activityEconomic = '' + vm.transactionSale.codeProduct.codigoActividad;
        }
    }

    function viewSpecialInvoiceCtrl(specialInvoice) {
        var vm = this;
        if (specialInvoice !== undefined) {
            vm.specialInvoice = specialInvoice;
            vm.name = specialInvoice.invoiceNumber;
        }
    }

    function annularSpecialInvoiceCtrl(specialInvoiceService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.invoiceId = $stateParams.id;
        vm.numberInvoice = $stateParams.numberInvoice;
        vm.annularSpecialInvoice = function(){
            specialInvoiceService.annularSpecialInvoice($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
